import './App.css';

function App() {
  return (
    <div className="App">
      <main>
        <img class="logo" src="./images/fjellmans-logo.svg" />
        <h1 class="title">Frisör</h1>
        <div class="tel-box">
          <h2 class="ring">Ring:</h2>
          <h2 class="number">023-222 20</h2>
        </div>

        <div class="adress-box">
          <h3 class="adress">ORNÄSGATAN 21 C</h3>
          <h3 class="">791 62 FALUN</h3>
        </div>

        <img class="main-image" src="./images/fjellmans.jpg" />
        <img class="icon" src="./images/fjellmans-ikon.svg" />
      </main>
    </div>
  );
}

export default App;
